<template>
    <div class="container">
      <Row>
        <Col span="4" offset="1"> <Breadcrumb>
          <BreadcrumbItem >
         首页
          </BreadcrumbItem>
          <BreadcrumbItem >
           联系我们
          </BreadcrumbItem>

        </Breadcrumb>
      
        </Col>
           <Divider />
      </Row>
     <Row>
       <Col span="4" offset="2" class="cardStyle">
         <Col span="23" offset="1" class="sider"><span @click="open"  >关于我们</span></Col>
         <Col span="23" offset="1" class="sider"><span @click="open1">联系我们</span></Col>
         <Col span="23" offset="1" class="sider"><span>帮助中心</span></Col>
         <Col span="23" offset="1" class="sider"><span>网站地址</span></Col>
         <Col span="23" offset="1" class="sider"><span @click="open4">用户反馈</span></Col>
       </Col>
       <Col span="17" offset="1"style="border-left: 1px solid lightgray">
         <template v-if="true==other">
          <aboutUs></aboutUs>
         </template>

      <template v-if="true==other1">

        <Col span="23" offset="1"><connects></connects></Col>
      </template>
         <template v-if="true==other4">

           <Col span="23" offset="1"><Ru></Ru></Col>

         </template>
         </Col>
     </Row>
    </div>
</template>

<script>
import  Ru from './components/return'
import  connects from './components/connect'
import  aboutUs from './components/aboutUs'
    export default {
        name: "index",
      components:{ connects,
        Ru,
        aboutUs
      },
        data(){

          return{

            other4:false,
            other1:false,
            other:true
          }
      },
      methods:{
        open:function () {
          this.other1=false;
          this.other4=false;
          this.other=true;

        },

          open1:function () {
            this.other1=true;
            this.other4=false;
            this.other=false;
          },
        open4:function () {
          this.other1=false;
          this.other=false;
          this.other4=true;

        }
      }
    }
</script>

<style scoped>

 .container{
   background: #e8e8e8;
   width: 100%;  
   margin: 0 auto;  
   height: auto;  
   padding:5px;
 }
  .sider{
  
    border-bottom: 1px dashed  gray;
    height: 30px;
    line-height: 30px;
    font-family: 微软雅黑;
    font-size: 15px;
    cursor: pointer;
    text-align: left;
  }
  .cardStyle{
     background: white;
  
    box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  }

</style>



// WEBPACK FOOTER //
// src/views/other/index.vue